

export interface AppError {
  message: string;
  status?: number;
  code?: string;
}

export const parseError = (error: any): AppError => {
  if (error.response) {

    const { status, data } = error.response;
    return {
      message: data?.message || data?.error || 'An error occurred',
      status,
      code: data?.code,
    };
  } else if (error.request) {

    return {
      message: 'Network error. Please check your connection.',
      code: 'NETWORK_ERROR',
    };
  } else {

    return {
      message: error.message || 'An unexpected error occurred',
      code: 'UNKNOWN_ERROR',
    };
  }
};

export const getErrorMessage = (error: any): string => {
  const appError = parseError(error);
  return appError.message;
};

export const isRetryableError = (error: any): boolean => {
  if (!error.response) return true; 
  const status = error.response.status;
  return status >= 500 || status === 408 || status === 429;
};

